import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { Cotizacion, obtenerServicios, obtenerFletes as obtenerFletesImport } from "app/logic/operativa/cotizacion";


function obtenerFletes(cotiz: models.CotizadorModelDTO) {
    return obtenerFletesImport(cotiz.Paquetes, cotiz.Sobres, cotiz.ImportesSobre.Flete, cotiz.DistanciaFlete);
}

export function obtenerCotizacionDeCotizacionModelDTO(model: models.CotizadorModelDTO): Cotizacion {
    const envio = obtenerFletes(model);
    const servicios = obtenerServicios(model.ImportesGuia, model.ServiciosAdicionales);

    return {
        grupos: [envio, servicios],
        descuentoFlete: model.ImportesGuia.ImporteDescuentoFlete,
        flete: model.ImportesGuia.Flete,    
        subtotal: model.ImportesGuia.Subtotal,
        iva: model.ImportesGuia.Iva,
        retencionIva: model.ImportesGuia.RetencionIva,
        total: model.ImportesGuia.Total
    };
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/ver/logic.tsx